// Import model
import { FilterRoomPhotoFileRequest } from '../models/FilterRoomPhotoFileRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { RoomPhotoFileCondition } from '../models/RoomPhotoFileCondition';
import { RoomPhotoFileFields } from '../models/RoomPhotoFileFields';
import { RoomPhotoFileIndexedFields } from '../models/RoomPhotoFileIndexedFields';

// Import dependency serializers (for complex types)
import { RoomPhotoFileConditionSerializer } from './RoomPhotoFileConditionSerializer';
import { RoomPhotoFileFieldsSerializer } from './RoomPhotoFileFieldsSerializer';
import { RoomPhotoFileIndexedFieldsSerializer } from './RoomPhotoFileIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterRoomPhotoFileRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterRoomPhotoFileRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterRoomPhotoFileRequest instance
   */
  static deserialize(json: string): FilterRoomPhotoFileRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterRoomPhotoFileRequest instance
   */
  static fromObject(obj: any): FilterRoomPhotoFileRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterRoomPhotoFileRequest');
    }


    const instance: FilterRoomPhotoFileRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as RoomPhotoFileIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as RoomPhotoFileFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        RoomPhotoFileConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterRoomPhotoFileRequest instances
   */
  static deserializeArray(json: string): FilterRoomPhotoFileRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterRoomPhotoFileRequest instance to a JSON string
   */
  static serialize(instance: FilterRoomPhotoFileRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterRoomPhotoFileRequest instance to a plain object
   */
  static toObject(instance: FilterRoomPhotoFileRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        RoomPhotoFileConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterRoomPhotoFileRequest instances to a JSON string
   */
  static serializeArray(instances: FilterRoomPhotoFileRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
